export default function PrintLabelBtn({ conteo = 0, handleShow }) {
	return (
		<button
			className="btn bg-agro-outline bg-agro-outline-save-btn"
			onClick={(_e) => {
				handleShow();
			}}
		>
			Imprimir Etiquetas <span className="badge badge-danger">{conteo}</span>
		</button>
	);
}
